import styled from '@emotion/styled';

import { ButtonVariant, ButtonTheme, ButtonState } from '@/styles/themes/button';

import { CoreButton, ICoreButtonProps, getButtonThemeConfig } from '../CoreButton';

export const HollowButton = styled(CoreButton)<ICoreButtonProps>`
  border: ${(props) => `1px solid ${getButtonThemeConfig(props, ButtonState.REGULAR).borderColor}`};
  justify-content: center;

  &:disabled {
    border-color: ${(props) => getButtonThemeConfig(props, ButtonState.DISABLED).borderColor};
  }
`;

HollowButton.defaultProps = {
  buttonTheme: ButtonTheme.LIGHT,
  variant: ButtonVariant.HOLLOW,
};
